import React from 'react';
import cnames from 'classnames';
import { FormattedMessage } from '../Intl';
import { SVGIcon } from '@homeaway/react-svg';
import { ARROW_RIGHT__24 } from '@homeaway/svg-defs';
import { PropTypes } from 'prop-types';
import { GREEN_VRBO_LOGO, NEW_VRBO_LOGO } from './VrboLogos';

import './VrboRefreshMessage.less';

const CNAME = 'VrboRefreshMessage';

const VrboRefreshMessage = ({ isTouchDevice }) => (
  <section className={cnames(
    'Content__section',
    'align-with-carousels',
    { 'align-with-carousels--touch': isTouchDevice
    })}
  >
    <div className={cnames(CNAME, { 'mobile': isTouchDevice })}>
      <div className={`${CNAME}__imageContent`}>
        <SVGIcon markup={GREEN_VRBO_LOGO} className={`${CNAME}__vrbo-logo`} />
        <SVGIcon markup={ARROW_RIGHT__24} />
        <SVGIcon markup={NEW_VRBO_LOGO} className={`${CNAME}__vrbo-logo`} />
      </div>
      <FormattedMessage id={['component.vrbo.brand.refresh.message.subheading']}>
        {
          subheading => <p className={`${CNAME}__textContent`}>{subheading}</p>
        }
      </FormattedMessage>
    </div>
  </section>
);

VrboRefreshMessage.propTypes = {
  isTouchDevice: PropTypes.bool.isRequired
};

export default VrboRefreshMessage;
